import { render, staticRenderFns } from "./ArrivalDate.vue?vue&type=template&id=b2e204c8"
import script from "./ArrivalDate.vue?vue&type=script&lang=js"
export * from "./ArrivalDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports